module.exports = __webpack_public_path__ + "static/media/video-reflective-thinking-es.3636c4f6.vtt";